import { useEffect, useState } from 'react';

export function useShiftPressed() {
  const [isShiftPressed, setIsShiftPressed] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        setIsShiftPressed(true);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        setIsShiftPressed(false);
      }
    };

    const resetShiftPressed = () => {
      setIsShiftPressed(false);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        resetShiftPressed();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', resetShiftPressed);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', resetShiftPressed);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isShiftPressed;
}
